import { render, staticRenderFns } from "./InfoOpenClass.vue?vue&type=template&id=fb8f6c04&scoped=true"
import script from "./InfoOpenClass.vue?vue&type=script&lang=js"
export * from "./InfoOpenClass.vue?vue&type=script&lang=js"
import style0 from "./InfoOpenClass.vue?vue&type=style&index=0&id=fb8f6c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8f6c04",
  null
  
)

export default component.exports